import * as XLSX from 'xlsx';

/**
 * Utility to export JavaScript objects to a styled Excel .xlsx workbook
 * @param {Array<Object>} data - Array of row objects
 * @param {String} filename - Name of downloaded file (excluding extension)
 * @param {String} sheetName - Title of the worksheet tab
 */
export const exportToExcel = (data, filename = 'export', sheetName = 'Sheet1') => {
  if (!data || data.length === 0) {
    alert('No records available to export.');
    return;
  }

  // Create worksheet from JSON
  const worksheet = XLSX.utils.json_to_sheet(data);

  // Auto-fit column widths based on contents
  const colWidths = [];
  const keys = Object.keys(data[0]);
  keys.forEach((key) => {
    let maxLen = key.length;
    data.forEach((row) => {
      const val = row[key] ? String(row[key]) : '';
      if (val.length > maxLen) {
        maxLen = val.length;
      }
    });
    colWidths.push({ wch: Math.min(Math.max(maxLen + 3, 12), 60) });
  });
  worksheet['!cols'] = colWidths;

  // Create workbook and write file
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  const dateStamp = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(workbook, `${filename}_${dateStamp}.xlsx`);
};
